import { useState, useEffect } from "react";

const validateEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailRegex.test(email);
};

const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

const validateForm = async (state) => {
    let firstError;
    let validationSuccess = true;
    let validationMessage = {};
    if (!state.email) {
        validationMessage.email = "businessRegister.validation.email";
        if (!firstError) firstError = "email";
        validationSuccess = false;
    } else {
        if (!validateEmail(state.email)) {
            validationMessage.email = "businessRegister.validation.emailInvalid";
            if (!firstError) firstError = "email";
            validationSuccess = false;
        }
    }

    if (!state.password) {
        validationMessage.password = "businessRegister.validation.password";
        if (!firstError) firstError = "password";
        validationSuccess = false;
    } else if (state.password.length < 8) {
        validationMessage.password = "businessRegister.validation.passwordInvalid";
        if (!firstError) firstError = "password";
        validationSuccess = false;
    }

    if (state.password !== state.confirmPassword) {
        validationMessage.confirmPassword = "businessRegister.validation.confirmPassword";
        if (!firstError) firstError = "confirmPassword";
        validationSuccess = false;
    }

    // Section 2
    if (!state.businessName) {
        validationMessage.businessName = "businessRegister.validation.businessName";
        if (!firstError) firstError = "businessName";
        validationSuccess = false;
    }
    if (!state.businessPhoneNumber) {
        validationMessage.businessPhoneNumber = "businessRegister.validation.businessPhoneNumber";
        if (!firstError) firstError = "businessPhoneNumber";
        validationSuccess = false;
    }
    if (!state.businessAddress) {
        validationMessage.businessAddress = "businessRegister.validation.businessAddress";
        if (!firstError) firstError = "businessAddress";
        validationSuccess = false;
    }
    if (!state.businessIndustry) {
        validationMessage.businessIndustry = "businessRegister.validation.businessIndustry";
        if (!firstError) firstError = "businessIndustry";
        validationSuccess = false;
    }
    if (!state.businessType) {
        validationMessage.businessType = "businessRegister.validation.businessType";
        if (!firstError) firstError = "businessType";
        validationSuccess = false;
    }
    if (!state.businessRegistrationNumber) {
        validationMessage.businessRegistrationNumber = "businessRegister.validation.businessRegistrationNumber";
        if (!firstError) firstError = "businessRegistrationNumber";
        validationSuccess = false;
    }

    // Section 3
    if (!state.contactFirstName) {
        validationMessage.contactFirstName = "businessRegister.validation.contactFirstName";
        if (!firstError) firstError = "contactFirstName";
        validationSuccess = false;
    }

    if (!state.contactLastName) {
        validationMessage.contactLastName = "businessRegister.validation.contactLastName";
        if (!firstError) firstError = "contactLastName";
        validationSuccess = false;
    }

    if (!state.contactPhoneNumber) {
        validationMessage.contactPhoneNumber = "businessRegister.validation.contactPhoneNumber";
        if (!firstError) firstError = "contactPhoneNumber";
        validationSuccess = false;
    }
    if (!state.contactEmail) {
        validationMessage.contactEmail = "businessRegister.validation.contactEmail";
        if (!firstError) firstError = "contactEmail";
        validationSuccess = false;
    } else {
        if (!validateEmail(state.contactEmail)) {
            validationMessage.contactEmail = "businessRegister.validation.contactEmailInvalid";
            if (!firstError) firstError = "contactEmail";
            validationSuccess = false;
        }
    }

    // Section 4
    // if (state.emailRecipients.some((recipient) => !validateEmail(recipient))) {
    //     validationMessage.emailRecipients = "Email format invalid";
    //     if (!firstError) firstError = "emailRecipients";
    //     validationSuccess = false;
    // }

    // Section 5
    const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE;

    if (!countryWithoutPostCode.split(',').includes(state.billingCountryCode)) {
        if (!state.billingPostalCode) {
            validationMessage.billingPostalCode = "businessRegister.validation.billingPostalCode";
            if (!firstError) firstError = "billingPostalCode";
            validationSuccess = false;
        }
    }

    if (!state.billingCountry) {
        validationMessage.billingCountry = "businessRegister.validation.billingCountry";
        if (!firstError) firstError = "billingCountry";
        validationSuccess = false;
    }
    if (!state.billingName) {
        validationMessage.billingName = "businessRegister.validation.billingName";
        if (!firstError) firstError = "billingName";
        validationSuccess = false;
    } else if (state.billingName.length < 3) {
        validationMessage.billingName = "businessRegister.validation.billingNameMinLength";
        if (!firstError) firstError = "billingName";
        validationSuccess = false;
    }
    if (!state.billingPhoneNumber) {
        validationMessage.billingPhoneNumber = "businessRegister.validation.billingPhoneNumber";
        if (!firstError) firstError = "billingPhoneNumber";
        validationSuccess = false;
    }
    if (!state.billingAddress) {
        validationMessage.billingAddress = "businessRegister.validation.billingAddress";
        if (!firstError) firstError = "billingAddress";
        validationSuccess = false;
    }

    // Section 5 Payment Method

    // Section 6 (Business License)
    // if (!businessLicenseFile) {
    //     validationMessage.businessLicenseFile =
    //         "Bussiness license businessRegister.validation.lice";
    //     if (!firstError)
    //         firstError = "businessLicenseFile";
    // validationSuccess = false;
    // }

    if (!state.license) {
        validationMessage.license = "businessRegister.validation.license";
        if (!firstError) firstError = "license";
        validationSuccess = false;
        validationSuccess = false;
    }

    return { validationSuccess, firstError, validationMessage };
};

export { validateForm, validateEmail, isValidEmail };